import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ForecastersState {
  siteOptions: any;
  forecastersList: any;
  websiteTargetList: any
  selectedSite: any;
  selectedSharedUid: any;
  selectedMetaSharedUid: any;
  selectedYear: string;
  selectedForecastStatus: string;
  selectedForecasterContent: any;
  selectedMonthData: any;
  selectedMonth: any;
  selectedMonthForecastContentSharedUid: string;
  pastMonthForcast: any;
  forecastGraphAndTableData: any;
  forecastLastYearData: any;
  forecastLastTwelveMonthsData: any;
  selectedMetric: string;
  selectedTemplateType: any;
  selectedDuplicateForecast: any;
  isAllReviewed: boolean;
  forecastStatus: 'draft' | 'publish' | null;
  forcastNote: string;
  showForecastData: boolean;
  allFieldsFilled: boolean;
  page: any;
  monthlyData: { [key: string]: any }; // Added to match the initial state structure
}

const initialState: ForecastersState = {
  siteOptions: [],
  forecastersList: null,
  websiteTargetList: null,
  selectedYear: new Date().getFullYear().toString(),
  selectedSite: null,
  selectedSharedUid: null,
  selectedMetaSharedUid: null,
  selectedForecastStatus: "",
  selectedForecasterContent: null,
  selectedMonthData: null,
  selectedMonth: null,
  selectedMonthForecastContentSharedUid: "",
  pastMonthForcast: null,
  forecastGraphAndTableData: null,
  forecastLastYearData: null,
  forecastLastTwelveMonthsData: null,
  selectedMetric: "",
  selectedTemplateType: null,
  selectedDuplicateForecast: null,
  isAllReviewed: false,
  forecastStatus: null,
  forcastNote: "",
  showForecastData: false,
  allFieldsFilled: false,
  page: 0,
  monthlyData: [] // Added to match the initial state structure
};

const forecastersSlice = createSlice({
  name: "forecasters",
  initialState,
  reducers: {
    setForecastersList: (state, action: PayloadAction<any>) => {
      state.forecastersList = action.payload;
    },
    setWebsiteTargetList: (state, action: PayloadAction<any>) => {
      state.websiteTargetList = action.payload;
    },
    setSelectedSharedUid: (state, action: PayloadAction<any>) => {
      state.selectedSharedUid = action.payload;
    },
    setSelectedMetaSharedUid: (state, action: PayloadAction<string>) => {
      state.selectedMetaSharedUid = action.payload;
    },
    setSelectedSite: (state, action: PayloadAction<any>) => {
      state.selectedSite = action.payload;
    },
    setSiteOptions: (state, action) => {
      state.siteOptions = action.payload;
    },
    setSelectedForecastStatus: (state, action: PayloadAction<string>) => {
      state.selectedForecastStatus = action.payload;
    },
    setSelectedYear: (state, action: PayloadAction<string>) => {
      state.selectedYear = action.payload;
    },
    setSelectedForecasterContent: (state, action: PayloadAction<any>) => {
      state.selectedForecasterContent = action.payload;
    },
    setSelectedMonthData: (state, action: PayloadAction<any>) => {
      state.selectedMonthData = action.payload;
    },
    setSelectedMonth(state, action: PayloadAction<any>) {
      state.selectedMonth = action.payload;
    },
    setSelectedMonthForecastContentSharedUid: (state, action: PayloadAction<string>) => {
      state.selectedMonthForecastContentSharedUid = action.payload;
    },
    setPastMonthForcast: (state, action: PayloadAction<any>) => {
      state.pastMonthForcast = action.payload;
    },
    setForecastGraphAndTableData(state, action: PayloadAction<any>) {
      state.forecastGraphAndTableData = action.payload;
    },
    setForcastLastYearData(state, action: PayloadAction<any>) {
      state.forecastLastYearData = action.payload;
    },
    setSelectedMetric(state, action: PayloadAction<string>) {
      state.selectedMetric = action.payload;
    },
    setForecastLastTwelveMonthsData(state, action: PayloadAction<any>) {
      state.forecastLastTwelveMonthsData = action.payload;
    },
    setSelectedTemplateType(state, action: PayloadAction<any>) {
      state.selectedTemplateType = action.payload;
    },
    setSelectedDuplicateForecast(state, action: PayloadAction<any>) {
      state.selectedDuplicateForecast = action.payload;
    },
    setAllReviewed: (state, action) => {
      state.isAllReviewed = action.payload;
    },
    setForecastStatus: (state, action: PayloadAction<'draft' | 'publish' | null>) => {
      state.forecastStatus = action.payload;
    },
    setForecastNote: (state, action: PayloadAction<string>) => {
      state.forcastNote = action.payload;
    },
    setShowForecastData: (state, action: PayloadAction<boolean>) => {
      state.showForecastData = action.payload;
    },
    setAllFieldsFilled: (state, action: PayloadAction<boolean>) => {
      state.allFieldsFilled = action.payload;
    },
    setPage: (state, action: PayloadAction<any>) => {
      state.page = action.payload;
    },
    setMonthlyData: (state,action:PayloadAction<any>)=>{
      state.monthlyData = action.payload;
    }
  }
});

export const {
  setForecastersList,
  setWebsiteTargetList,
  setSiteOptions,
  setSelectedSite,
  setSelectedSharedUid,
  setSelectedMetaSharedUid,
  setSelectedYear,
  setSelectedForecastStatus,
  setSelectedForecasterContent,
  setSelectedMonthData,
  setSelectedMonth,
  setSelectedMonthForecastContentSharedUid,
  setPastMonthForcast,
  setForecastGraphAndTableData,
  setForcastLastYearData,
  setForecastLastTwelveMonthsData,
  setSelectedMetric,
  setSelectedTemplateType,
  setSelectedDuplicateForecast,
  setAllReviewed,
  setForecastStatus,
  setForecastNote,
  setShowForecastData,
  setAllFieldsFilled,
  setPage,
  setMonthlyData
} = forecastersSlice.actions;

export default forecastersSlice.reducer;
